import React from 'react';
import { Box, Typography } from '@mui/material';
import {MAIN_COLOR_BLUE} from "../../utils/styles";


const NotFoundLayout =() => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: MAIN_COLOR_BLUE,
            }}
        >
            <Typography variant="h1" style={{color: 'white'}}>
                404 Not Found
            </Typography>
        </Box>
    );
}
export default NotFoundLayout
